// School / Learning Institution — exact Figma content
// Frames: 02 School Overview (28:2), 03 Learning Experiences (45:2), 04 How It Works (45:332)

export const SCHOOL_NAV = [
  { label: 'Overview',        to: '/school' },
  { label: 'VR Experiences',  to: '/school/experiences' },
  { label: 'How It Works',    to: '/school/how-it-works' },
  { label: 'Deployment',      to: '/school/deployment' },
  { label: 'Evidence',        to: '/school/evidence' },
  { label: 'FAQ',             to: '/school/faq' },
];

export const SCHOOL_CTA = {
  primary:   { label: 'Start Deployment', to: '/school/start-deployment' },
  secondary: { label: 'Login',            to: '#login' },
};

export const SCHOOL_FOOTER = {
  brandNote: 'Conceptualized, designed and developed by Dr. Keyur Sorathia & team at the Embedded Interaction Lab, Department of Design, IIT Guwahati.',
  cols: [
    { title: 'School Deployment', items: [
      { label: 'Overview',            to: '/school' },
      { label: 'Learning Experiences',to: '/school/experiences' },
      { label: 'How It Works',        to: '/school/how-it-works' },
      { label: 'Deployment',          to: '/school/deployment' },
    ]},
    { title: 'Support', items: [
      { label: 'Evidence',        to: '/school/evidence' },
      { label: 'FAQ',             to: '/school/faq' },
      { label: 'Request Demo',    to: '/school/request-demo' },
      { label: 'Start Deployment',to: '/school/start-deployment' },
    ]},
    { title: 'Access', items: [
      { label: 'School portal',     to: '#school-portal' },
      { label: 'Teacher dashboard', to: '#teacher-dashboard' },
      { label: 'Coordinator tools', to: '#coordinator' },
    ]},
  ],
};

// =============================================================================
// 02 SCHOOL OVERVIEW — Frame 28:2
// =============================================================================
export const SCHOOL_OVERVIEW = {
  hero: {
    eyebrow: 'FOR SCHOOLS & LEARNING INSTITUTIONS',
    title: 'NCERT-aligned immersive learning for Grades 8 and 9',
    desc:  'Science and Mathematics learning through interactive VR, multilingual AI guidance, assessments and school analytics.',
    pill:  'Complete software ecosystem with no licence fee through June 2027.',
    ctaPrimary: { label: 'Start a School Deployment', to: '/school/start-deployment' },
    ctaSecondary:{ label: 'Request Online Demo',     to: '/school/request-demo' },
    videoLabel: 'View Gyan Dhara in action',
    signOff:   'Conceptualized, designed and developed by Dr. Keyur Sorathia & team at the Embedded Interaction Lab, Department of Design, IIT Guwahati',
    partners: [
      { label: 'IIT Guwahati' },
      { label: 'Department of Science & Technology, Government of Assam' },
    ],
  },
  layers: {
    eyebrow: 'THE LEARNING SYSTEM',
    title:   'Three connected layers of learning',
    desc:    'Students experience concepts, practise through assessments, and teachers and parents understand progress.',
    items: [
      { key: 'VR', title: 'Learn in VR',           desc: 'Self-guided modules transform difficult Science and Mathematics concepts into interactive experiences.', color: 'purple', icon: 'Headset' },
      { key: '✓',  title: 'Practise & assess',    desc: 'Unlimited conceptual, theoretical and applied quizzes reinforce understanding beyond recall.',            color: 'royal',  icon: 'ClipboardCheck' },
      { key: '▥',  title: 'Understand progress', desc: 'Teachers and parents view module completion, time spent and quiz performance.',                              color: 'mint',   icon: 'BarChart3' },
    ],
  },
  purpose: {
    eyebrow: 'PURPOSE',
    title:   'Building innovators, problem-solvers and future scientists for Viksit Bharat',
    desc:    'Immersive learning is the means—not the final goal. Gyan Dhara strengthens conceptual clarity, accurate mental models, scientific curiosity and applied problem-solving.',
    items: [
      { title: 'Conceptual clarity',        desc: 'Build accurate mental models.',       color: 'purple', icon: 'Target' },
      { title: 'Experiential application',  desc: 'Connect theory with action.',         color: 'royal',  icon: 'Beaker' },
      { title: 'Joyful exploration',        desc: 'Learn through curiosity and discovery.', color: 'cyan', icon: 'Sparkles' },
      { title: 'Evidence-led improvement',  desc: 'Refine through school evaluation.',   color: 'mint',   icon: 'BarChart3' },
    ],
  },
  curriculum: {
    eyebrow: 'NCERT CURRICULUM LEARNING',
    title:   'Available, in development and upcoming',
    desc:    'Grade 8 and 9 Science and Mathematics modules.',
    available: [
      { title: 'Sound',                   chapter: 'Grade 8 · Science',            subject: 'Science',      status: 'Available' },
      { title: 'Combustion & Flame',      chapter: 'Grade 8 · Science',            subject: 'Science',      status: 'Available' },
      { title: 'Friction',                chapter: 'Grade 8 · Science',            subject: 'Science',      status: 'Available' },
      { title: 'Perimeter',               chapter: 'Grade 8 · Mathematics',        subject: 'Mathematics',  status: 'Available' },
      { title: 'Area 2D',                 chapter: 'Grade 8 · Mathematics',        subject: 'Mathematics',  status: 'Available' },
      { title: 'Area 3D',                 chapter: 'Grade 9 · Mathematics',        subject: 'Mathematics',  status: 'Available' },
      { title: 'Volume',                  chapter: 'Grade 9 · Mathematics',        subject: 'Mathematics',  status: 'Available' },
      { title: 'Zero Gravity',            chapter: 'Grade 9 · Science · Gravitation', subject: 'Science',   status: 'Available' },
      { title: "Gravity's Grip",          chapter: 'Grade 9 · Science · Gravitation', subject: 'Science',   status: 'Available' },
      { title: 'AeroQuest',              chapter: 'Science · Applied physics',    subject: 'Science',      status: 'Available' },
      { title: 'Falltopia',               chapter: 'Grade 9 · Science · Gravitation', subject: 'Science',   status: 'Available' },
      { title: 'Human Excretory System',  chapter: 'NCERT-linked Science · Biology', subject: 'Science',    status: 'Available' },
    ],
    inDev: {
      label: 'In development',
      items: 'Work · Energy · Contact & Non-contact Forces · Area of Cone · Area of Sphere · Structure of Atom · Light',
      note:  'Videos will be added when modules are ready.',
    },
  },
  beyond: {
    eyebrow: 'EXPLORE BEYOND THE TEXTBOOK',
    title:   'Gyan Mitra and Gyan Vatikas',
    desc:    'Exploratory experiences expand curiosity across space, heritage, history, art, nature and human experience.',
    items: [
      { title: 'Gyan Mitra',              chapter: 'Multilingual AI guide',          subject: 'Human experience',    status: 'Available' },
      { title: 'Gyan Prangan',            chapter: 'Welcome and orientation space',  subject: 'Nature',              status: 'Available' },
      { title: 'Taj Mahal',               chapter: 'Heritage exploration',           subject: 'History',             status: 'Available' },
      { title: 'Qutub Minar',             chapter: 'Heritage exploration',           subject: 'History',             status: 'Available' },
      { title: 'India Gate',              chapter: 'Heritage exploration',           subject: 'History',             status: 'Available' },
      { title: 'Age of Dinosaurs',        chapter: 'Natural history',                subject: 'Nature',              status: 'Available' },
      { title: 'Lost World Expedition',   chapter: 'Natural history',                subject: 'Nature',              status: 'Available' },
      { title: 'Living World Safari',     chapter: 'Living animals',                 subject: 'Nature',              status: 'Available' },
      { title: 'Experience Space Station',chapter: 'Space exploration',              subject: 'Space',               status: 'Upcoming' },
      { title: '3D Painting',             chapter: 'Creative exploration',           subject: 'Art',                 status: 'Upcoming' },
      { title: 'Anne Frank House',        chapter: 'History and empathy',            subject: 'History',             status: 'Upcoming' },
      { title: 'Pollinator Park',         chapter: 'Ecology and sustainability',     subject: 'Environment',         status: 'Upcoming' },
    ],
  },
  timetable: {
    eyebrow: 'CLASSROOM USE',
    title:   'Designed to fit within the school timetable',
    desc:    'Schools can schedule a dedicated Gyan Dhara period similar to a library, games, activity or laboratory period.',
    steps: [
      { n: 1, title: 'Create a period',         desc: 'Choose a regular timetable slot.',      color: 'purple', icon: 'CalendarClock' },
      { n: 2, title: 'One student per headset', desc: 'Individual, self-guided use.',          color: 'royal',  icon: 'UserCircle' },
      { n: 3, title: '35–45 minute session',    desc: 'Complete one learning module.',         color: 'cyan',   icon: 'Timer' },
      { n: 4, title: 'Review progress',         desc: 'View usage and quiz analytics.',        color: 'mint',   icon: 'LineChart' },
    ],
  },
  estimate: {
    eyebrow: 'SETUP',
    title:   'Estimate the setup your school may need',
    desc:    'Recommended ratio: one VR headset for approximately 20 students. Minimum deployment: three Meta Quest 3S headsets.',
    inputLabel: 'Number of Grade 8 and 9 students',
    inputPlaceholder: 'Enter number',
    buttonLabel: 'Calculate',
    resultLabel: 'Recommended setup',
    resultExample: '5 headsets for 100 students',
    tailored: {
      title: 'Need a tailored configuration?',
      desc:  'Share your student count and preferred use. We will recommend the appropriate setup.',
      cta:   { label: 'Request a Custom Deployment Estimate', to: '/school/request-demo' },
    },
  },
  institutionFunded: {
    eyebrow: 'INSTITUTION-FUNDED COMPONENTS',
    title:   'Clear separation between software access and deployment costs',
    desc:    'Gyan Dhara coordinates procurement, configuration and dispatch. The institution funds hardware and applicable deployment components.',
    required: {
      title: 'Required for deployment',
      items: [
        'Minimum three Meta Quest 3S headsets',
        'Recommended comfort straps',
        'Rotating stools',
        'Meta device-management and remote-access setup',
        'Initial configuration and software installation',
        'Packaging, courier and logistics',
        'Applicable external vendor charges',
      ],
    },
    optional: {
      title: 'Optional based on requirements',
      items: [
        'Additional headsets',
        'TV or computer for casting',
        'Dedicated internet for Gyan Mitra',
        'Room branding and storage',
        'Extended training and technical support',
        'Annual maintenance',
        'Hardware repair and replacement',
      ],
    },
  },
  includedAccess: {
    eyebrow: 'INCLUDED ACCESS',
    title:   'Complete software access through June 2027',
    desc:    'All software modules, dashboards, updates and learning resources are provided without a licence fee during the access period.',
    listTitle: 'Included without a software licence fee',
    items: [
      'All curriculum VR modules',
      'Exploratory experiences',
      'New modules and software updates',
      'Gyan Mitra',
      'Student, teacher and parent portals',
      'Unlimited conceptual, theoretical and applied quizzes',
      'Chapter videos, visual resources and visual PDFs',
      'Teacher-uploaded learning materials',
      'Learning analytics',
    ],
    ctaPrimary:  { label: 'Request an Online Demo',    to: '/school/request-demo' },
    ctaSecondary:{ label: 'Start a School Deployment', to: '/school/start-deployment' },
  },
  developedAt: {
    eyebrow: 'DEVELOPED AT IIT GUWAHATI',
    title:   'Conceptualized, designed and developed by Dr. Keyur Sorathia & team at the Embedded Interaction Lab, Department of Design, IIT Guwahati',
    desc:    'Gyan Dhara is built by a multidisciplinary team of design researchers, UX designers, VR developers, technical artists and school educators.',
    highlightTitle: 'Research-led design for real school conditions',
    highlightDesc:  'Teacher consultations identify difficult concepts. The team translates these needs into immersive modules, evaluates them in schools, and uses the findings to refine learning, interaction and outcomes.',
    ctaPrimary:  { label: 'About Gyan Dhara', to: '/about' },
    ctaSecondary:{ label: 'Meet the Team',    to: '/team' },
    imageLabel:  'TEAM / SCHOOL CO-DESIGN PHOTO',
  },
  analytics: {
    eyebrow: 'LEARNING ANALYTICS',
    title:   'A teacher dashboard that makes progress visible',
    desc:    'Individual student accounts enable module completion, time spent and quiz-performance tracking.',
    listTitle: 'Teacher-visible insights',
    list: [
      'Modules started and completed',
      'Time spent in each chapter',
      'Quiz scores by student',
      'Conceptual, theoretical and applied performance',
      'Learning outcomes covered',
      'Exportable reports',
    ],
  },
  realUse: {
    eyebrow: 'REAL SCHOOL USE',
    title:   'See Gyan Dhara in action',
    desc:    'The future deployment film will show the full student journey. Existing clips demonstrate real student use.',
    mainVideo: {
      label: 'Gyan Dhara school deployment',
      desc:  'Setup, orientation, module use, coordinator support and the portable classroom arrangement.',
    },
    clips: [
      { title: 'Student clip 1', note: 'Uploaded field video' },
      { title: 'Student clip 2', note: 'Uploaded field video' },
      { title: 'Student clip 3', note: 'Uploaded field video' },
    ],
  },
  deployment: {
    eyebrow: 'SCHOOL DEPLOYMENT',
    title:   'Designed for practical adoption',
    desc:    'One headset is recommended for approximately 20 students. The minimum setup is three Meta Quest 3S headsets.',
    metrics: [
      { k: '3+',       label: 'Minimum headsets',    note: 'Quest 3S with comfort straps' },
      { k: '1:20',     label: 'Recommended ratio',   note: 'One headset for approximately 20 students' },
      { k: 'Offline',  label: 'Core learning',       note: 'Internet required only for Gyan Mitra and sync' },
      { k: '7–10 days',label: 'Typical deployment',  note: 'After agreement and hardware/logistics funds' },
    ],
  },
  press: {
    eyebrow: 'RECOGNITION',
    title:   'Featured in the media',
    desc:    'Independent coverage and institutional recognition support trust in the initiative.',
    items: [
      { label: 'PRESS TRUST OF INDIA', color: 'purple', url: 'https://www.ptinews.com/story/national/IIT-Guwahati-developing-India-s-first-VR-enabled-metaverse-platform-for-PM-SHRI-schools-in-Assam/2368019' },
      { label: 'THE WEEK',              color: 'royal', url: 'https://www.theweek.in/wire-updates/national/2025/03/12/del12-iit-metaverse-schools.html' },
      { label: 'BUSINESS STANDARD',     color: 'cyan',  url: 'https://www.business-standard.com/technology/tech-news/iit-guwahati-developing-india-s-1st-vr-metaverse-for-pm-shri-schools-125031200262_1.html' },
      { label: 'HINDUSTAN TIMES',       color: 'mint',  url: 'https://www.hindustantimes.com/education/features/iit-guwahati-developing-indias-first-vr-enabled-metaverse-platform-for-pm-shri-schools-101741763421778.html' },
      { label: 'ECONOMIC TIMES',        color: 'purple',url: 'https://www.hindustantimes.com/education/features/iit-guwahati-developing-indias-first-vr-enabled-metaverse-platform-for-pm-shri-schools-101741763421778.html' },
      { label: 'TIMES OF INDIA',        color: 'royal', url: 'https://timesofindia.indiatimes.com/city/guwahati/iit-g-set-to-launch-virtual-reality-labs-to-help-students-to-grasp-complex-concepts/articleshow/118946252.cms' },
    ],
  },
  cta: {
    title:  'Bring the future of learning to your school.',
    desc:   'Request an online demonstration or begin a deployment discussion.',
    primary:  { label: 'Start a School Deployment', to: '/school/start-deployment' },
    secondary:{ label: 'Request Online Demo',       to: '/school/request-demo' },
  },
};

// =============================================================================
// 03 LEARNING EXPERIENCES — Frame 45:2
// =============================================================================
export const SCHOOL_EXPERIENCES = {
  hero: {
    title: 'Learning experiences built for understanding',
    desc:  'Explore NCERT-aligned Science and Mathematics modules alongside immersive experiences in space, history, art and science.',
  },
  curriculum: {
    eyebrow: 'CURRICULUM MODULES',
    title:   'NCERT Science and Mathematics',
    desc:    'Grades 8 and 9 · English, Hindi and Assamese · Typical session: 35–45 minutes · Statuses: Available, In Development and Upcoming',
    items: [
      { title: 'Sound',                   chapter: 'Grade 8 · Science',                subject: 'Science',      status: 'Available' },
      { title: 'Combustion & Flame',      chapter: 'Grade 8 · Science',                subject: 'Science',      status: 'Available' },
      { title: 'Friction',                chapter: 'Grade 8 · Science',                subject: 'Science',      status: 'Available' },
      { title: 'Perimeter',               chapter: 'Grade 8 · Mathematics',            subject: 'Mathematics',  status: 'Available' },
      { title: 'Area 2D',                 chapter: 'Grade 8 · Mathematics',            subject: 'Mathematics',  status: 'Available' },
      { title: 'Area 3D',                 chapter: 'Grade 9 · Mathematics',            subject: 'Mathematics',  status: 'Available' },
      { title: 'Volume',                  chapter: 'Grade 9 · Mathematics',            subject: 'Mathematics',  status: 'Available' },
      { title: 'Zero Gravity',            chapter: 'Grade 9 · Science · Gravitation',  subject: 'Science',      status: 'Available' },
      { title: "Gravity's Grip",          chapter: 'Grade 9 · Science · Gravitation',  subject: 'Science',      status: 'Available' },
      { title: 'AeroQuest',              chapter: 'Science · Applied physics',        subject: 'Science',      status: 'Available' },
      { title: 'Falltopia',               chapter: 'Grade 9 · Science · Gravitation',  subject: 'Science',      status: 'Available' },
      { title: 'Human Excretory System',  chapter: 'NCERT-linked Science · Biology',   subject: 'Science',      status: 'Available' },
      { title: 'Work',                    chapter: 'Grade 9 · Science',                subject: 'Science',      status: 'In development' },
      { title: 'Energy',                  chapter: 'Grade 9 · Science',                subject: 'Science',      status: 'In development' },
      { title: 'Light',                   chapter: 'Science',                          subject: 'Science',      status: 'In development' },
      { title: 'Structure of Atom',       chapter: 'Science',                          subject: 'Science',      status: 'In development' },
      { title: 'Contact & Non-contact Forces', chapter: 'Science',                     subject: 'Science',      status: 'In development' },
      { title: 'Area of Cone',            chapter: 'Mathematics',                      subject: 'Mathematics',  status: 'In development' },
      { title: 'Area of Sphere',          chapter: 'Mathematics',                      subject: 'Mathematics',  status: 'In development' },
      { title: 'Volume of Sphere and Cone', chapter: 'Mathematics',                    subject: 'Mathematics',  status: 'In development' },
    ],
  },
  exploration: {
    eyebrow: 'EXPLORATION',
    title:   'Beyond direct NCERT alignment',
    desc:    'Space, history, art and scientific exploration that expands curiosity without being presented as textbook-aligned.',
    items: [
      { title: 'Experience Space Station', chapter: 'Space exploration',            subject: 'Space',              status: 'Available' },
      { title: 'Age of Dinosaurs',        chapter: 'Natural history',              subject: 'Nature',             status: 'Available' },
      { title: 'Living World Safari',     chapter: 'Living animals in nature',     subject: 'Nature',             status: 'Available' },
      { title: 'Lost World Expedition',   chapter: 'Extinct animals and worlds',   subject: 'Nature',             status: 'Available' },
      { title: 'Taj Mahal',               chapter: 'History and architecture',     subject: 'History',            status: 'Available' },
      { title: 'Qutub Minar',             chapter: 'History and architecture',     subject: 'History',            status: 'Available' },
      { title: 'India Gate',              chapter: 'History and heritage',         subject: 'History',            status: 'Available' },
      { title: '3D Painting',             chapter: 'Creative exploration',         subject: 'Art',                status: 'Available' },
      { title: 'Anne Frank Experience',   chapter: 'History',                      subject: 'History',            status: 'Available' },
      { title: 'Notes on Blindness',      chapter: 'Perspective and accessibility',subject: 'Human experience',   status: 'Available' },
      { title: 'Pollinator Park',         chapter: 'Environment and ecosystems',   subject: 'Environment',        status: 'Available' },
    ],
  },
  moduleDetail: {
    eyebrow: 'MODULE DETAIL',
    title:   'What schools can inspect before deployment',
    desc:    'Each module page will show learning outcomes, session duration, screenshots or video, supported languages and current availability.',
    exampleTitle: 'Example: Sound',
    exampleBody:  [
      { k: 'Learning outcome', v: 'understand vibration, pitch, amplitude and sound propagation through interactive experimentation.' },
      { k: 'Duration',         v: '35–45 minutes' },
      { k: 'Languages',        v: 'English, Hindi, Assamese' },
      { k: 'Status',           v: 'Available' },
    ],
    mediaLabel: 'MODULE VIDEO / SCREENSHOTS',
  },
  cta: {
    title:  'Ready to bring Gyan Dhara to your institution?',
    desc:   'Request a demo or begin a deployment discussion.',
    primary:  { label: 'Start Deployment', to: '/school/start-deployment' },
    secondary:{ label: 'Request Demo',     to: '/school/request-demo' },
  },
};

// =============================================================================
// 04 HOW IT WORKS — Frame 45:332
// =============================================================================
export const SCHOOL_HOW = {
  hero: {
    title: 'How Gyan Dhara works in a school',
    desc:  'A practical operating model designed for existing timetables, portable classrooms and limited infrastructure.',
  },
  model: {
    eyebrow: 'SCHOOL MODEL',
    title:   'From timetable to learning analytics',
    desc:    'Gyan Dhara can run as a dedicated period similar to a library, games, activity or laboratory period.',
    steps: [
      { n: 1, title: 'Schedule the period',    desc: 'The school decides the class rotation and timetable.',                              color: 'purple', icon: 'CalendarClock' },
      { n: 2, title: 'Prepare the devices',    desc: 'Configured Quest 3S headsets and stools are placed in a classroom or activity space.', color: 'royal',  icon: 'Headset' },
      { n: 3, title: 'Five-minute orientation',desc: 'Students learn headset use and basic navigation.',                                  color: 'cyan',   icon: 'Clock' },
      { n: 4, title: 'Complete a module',      desc: 'One student per headset completes a self-guided 35–45 minute module.',              color: 'mint',   icon: 'CheckCircle2' },
      { n: 5, title: 'Continue on the portal', desc: 'Students use videos, visual resources and quizzes outside VR.',                     color: 'purple', icon: 'Laptop' },
      { n: 6, title: 'Review progress',        desc: 'Teachers and parents view usage and performance analytics.',                        color: 'royal',  icon: 'LineChart' },
    ],
  },
  scenarios: {
    eyebrow: 'CLASSROOM SCENARIOS',
    title:   'Choose a deployment pattern',
    desc:    'A dedicated VR laboratory is optional.',
    items: [
      { title: 'Portable classroom setup',  desc: 'Headsets and stools move between classrooms according to the timetable.', color: 'purple', icon: 'Package' },
      { title: 'Shared activity room',      desc: 'Use a library, games room, computer room or multipurpose space.',        color: 'royal',  icon: 'Users' },
      { title: 'Dedicated Gyan Dhara room', desc: 'A permanent setup for schools with higher usage.',                         color: 'mint',   icon: 'Home' },
    ],
  },
  connectivity: {
    eyebrow: 'ACCOUNTS AND CONNECTIVITY',
    title:   'Offline-first with optional connected services',
    desc:    'Core modules work offline. Internet is required for Gyan Mitra and data synchronisation.',
    items: [
      { title: 'Individual student accounts', desc: 'Recommended. Enables module-level VR analytics, completion tracking, time spent and quiz performance.', color: 'purple', icon: 'UserCircle' },
      { title: 'Shared access',                desc: 'Permitted when a school does not want individual accounts, but individual VR analytics will not be available.', color: 'cyan',  icon: 'Users2' },
    ],
    footnotes: [
      { icon: 'WifiOff',     text: 'Core modules and classroom use work offline' },
      { icon: 'Wifi',        text: 'Internet is used for Gyan Mitra and data synchronisation' },
    ],
  },
  roles: {
    eyebrow: 'ROLES',
    title:   'Who does what',
    desc:    'The school owns daily operations; Gyan Dhara manages software and remote configuration.',
    items: [
      { title: 'Students',           desc: 'Use one headset each, complete modules and access quizzes and resources.',                     color: 'purple', icon: 'GraduationCap' },
      { title: 'School coordinator', desc: 'Schedules sessions, charges, stores and cleans devices, and supports student champions.',       color: 'royal',  icon: 'ClipboardCheck' },
      { title: 'Gyan Dhara team',    desc: 'Performs initial configuration, software installation, updates and optional paid support.',     color: 'mint',   icon: 'Settings' },
    ],
  },
  cta: {
    title:  'Ready to bring Gyan Dhara to your institution?',
    desc:   'Request a demo or begin a deployment discussion.',
    primary:  { label: 'Start Deployment', to: '/school/start-deployment' },
    secondary:{ label: 'Request Demo',     to: '/school/request-demo' },
  },
};

// =============================================================================
// 05 DEPLOYMENT — Frame 45:452
// =============================================================================
export const SCHOOL_DEPLOYMENT = {
  hero: {
    title: 'Deploy Gyan Dhara in approximately 7–10 days',
    desc:  'Every institution is eligible. The process begins after the school confirms the minimum setup and deployment requirements.',
    ctaPrimary:  { label: 'Start Deployment',   to: '/school/start-deployment' },
    ctaSecondary:{ label: 'Request Online Demo',to: '/school/request-demo' },
  },
  requirements: {
    eyebrow: 'REQUIREMENTS',
    title:   'Minimum deployment standard',
    desc:    'One headset is recommended for approximately 20 students. The minimum setup is three Meta Quest 3S headsets.',
    required: {
      title: 'Required for deployment',
      items: [
        'Minimum three Meta Quest 3S headsets',
        'Recommended comfort straps',
        'Rotating stools',
        'Meta device-management and remote-access setup',
        'Initial configuration and software installation',
        'Packaging, courier and logistics',
        'Applicable external vendor charges',
      ],
    },
    optional: {
      title: 'Optional based on requirements',
      items: [
        'Additional headsets',
        'TV or computer for casting',
        'Dedicated internet for Gyan Mitra',
        'Room branding and storage',
        'Extended training and technical support',
        'Annual maintenance',
        'Hardware repair and replacement',
      ],
    },
  },
  estimator: {
    eyebrow: 'ESTIMATOR',
    title:   'Recommended headset quantity',
    desc:    'Enter the total number of Grade 8 and 9 students.',
    inputLabel: 'Student count',
    buttonLabel: 'Calculate',
    resultExample: 'Example: 100 students → 5 headsets',
    customCta: { label: 'Request custom estimate', to: '/school/request-demo' },
  },
  accessModel: {
    eyebrow: 'ACCESS MODEL',
    title:   'What is included and what is funded',
    desc:    '',
    included: {
      title: 'No software licence fee through June 2027',
      body:  'All VR modules, exploratory experiences, updates, future modules released during the period, Gyan Mitra, student portal, teacher dashboard, parent dashboard, unlimited quizzes and learning resources.',
    },
    funded: {
      title: 'Institution-funded components',
      body:  'Hardware, straps, stools, device-management setup, initial physical configuration, courier, logistics and any optional training, technical support, annual maintenance, room setup or repairs.',
    },
  },
  process: {
    eyebrow: 'PROCESS',
    title:   'Four stages to begin',
    desc:    '',
    stages: [
      { n: 1, title: 'Submit interest',          desc: 'Provide institution, student and setup information.',                        color: 'purple', icon: 'FileText' },
      { n: 2, title: 'Requirements discussion',  desc: 'Gyan Dhara responds within 48 hours and recommends a setup.',                color: 'royal',  icon: 'MessageCircle' },
      { n: 3, title: 'Agreement',                desc: 'Sign the collaboration and deployment agreement and fund hardware and logistics.', color: 'cyan',   icon: 'FileSignature' },
      { n: 4, title: 'Configuration and dispatch', desc: 'Headsets, accounts, software and accessories are prepared and couriered.', color: 'mint',   icon: 'Truck' },
    ],
  },
  timeline: {
    title: 'Expected access: approximately 7–10 days',
    desc:  'Timing begins after agreement and receipt of the required hardware and logistics funds.',
    cta:   { label: 'Start Deployment', to: '/school/start-deployment' },
  },
  cta: {
    title: 'Ready to bring Gyan Dhara to your institution?',
    desc:  'Request a demo or begin a deployment discussion.',
    primary:  { label: 'Start Deployment', to: '/school/start-deployment' },
    secondary:{ label: 'Request Demo',     to: '/school/request-demo' },
  },
};

// =============================================================================
// 06 EVIDENCE — Frame 47:2
// =============================================================================
export const SCHOOL_EVIDENCE = {
  hero: {
    title: 'Evidence developed through school-based research',
    desc:  'Gyan Dhara is being evaluated in real school settings for conceptual understanding, applied learning, retention, usability and operational feasibility.',
  },
  status: {
    eyebrow: 'CURRENT STATUS',
    title:   'Field evaluation with 111 students, four learning domains',
    desc:    "Pre / Post / 6-week Retention design tested across Theoretical, Conceptual, Applied and Misconception-Correction domains. Preliminary findings below; validated results will be published after full analysis.",
    cards: [
      { title: 'What is being studied',   desc: 'Immediate learning, 6-week retention, comfort and safety, student perceptions and classroom feasibility.', color: 'purple', icon: 'Microscope' },
      { title: 'How it is studied',        desc: 'Pre & post tests + 6-week retention, engagement & presence Likert scales, in-situ observation, student feedback and school implementation data.', color: 'royal', icon: 'ClipboardList' },
      { title: 'What is not claimed yet',  desc: 'No public claim of proven impact until the ongoing formal analysis and reporting are complete.',              color: 'cyan',   icon: 'ShieldAlert' },
    ],
    mediaLabel: 'FIELD-TRIAL VIDEO',
  },
  journey: {
    eyebrow: 'EVALUATION JOURNEY',
    title:   'From classroom problem to evidence',
    desc:    'A formal research & analysis process for product development and impact assessment.',
    steps: [
      { n: 1, title: 'Teacher consultations', desc: 'Identify concepts students struggle to visualise.',           color: 'purple', icon: 'MessagesSquare' },
      { n: 2, title: 'Module development',    desc: 'Design immersive experiences around learning outcomes.',      color: 'royal',  icon: 'Code2' },
      { n: 3, title: 'School field trials',   desc: 'Observe use, comprehension and operational issues.',          color: 'cyan',   icon: 'Building2' },
      { n: 4, title: 'Assessment',            desc: 'Compare conceptual, theoretical and applied performance.',    color: 'mint',   icon: 'ClipboardCheck' },
      { n: 5, title: 'Retention study',       desc: 'Measure what remains after the learning session.',            color: 'purple', icon: 'Brain' },
      { n: 6, title: 'Reporting',             desc: 'Publish validated findings and recommendations.',              color: 'royal',  icon: 'FileBarChart' },
    ],
  },
  preliminary: {
    eyebrow: 'PRELIMINARY FINDINGS',
    title:   'What the field study shows so far',
    desc:    "Gyan Dhara's VR science modules were tested with a Pre / Post / 6-week Retention design across four learning domains — Theoretical, Conceptual, Applied and Misconception Correction — with a sample of 111 students.",
    stats: [
      { k: '0.0002',   label: 'Overall learning gain',   note: 'Wilcoxon p-value · statistically significant' },
      { k: '~72%',     label: 'Learning retained',       note: 'Gains held six weeks later (Sound module)' },
      { k: '~75%',     label: 'Enjoyed & would reuse',   note: 'Student agreement across both modules' },
      { k: '97%',      label: 'Sessions completed',      note: 'Only 3 of 111 stopped for discomfort' },
      { k: 'd = 0.03', label: 'Gender parity',           note: 'No meaningful gap between male & female gains' },
    ],
    summaryTitle: 'Key findings',
    summaryBullets: [
      'VR produced real, measurable learning gains — strongest in Applied learning and Misconception Correction, the domains VR is best suited to.',
      'Learning lasted — Sound-module gains measured immediately after the session were statistically indistinguishable six weeks later.',
      'Students loved it — around three-quarters agreed or strongly agreed on enjoyment and willingness to reuse.',
      'Comfort and safety were strong — median symptom rating was "none"; symptoms were mild and infrequent, and only 2.7% of sessions ended due to discomfort.',
      'Equitable outcomes — no meaningful difference in learning gains between male and female students (d = 0.03, negligible).',
      'Feasible to deploy in rural classrooms — most students completed the experience independently after brief facilitator support in the first few minutes.',
    ],
    themesTitle: 'What we observed (qualitative themes)',
    themes: [
      'Rapid adaptation — cautious at first, confident within minutes.',
      'Learning through visualisation — seeing concepts, not just hearing them.',
      'High immersion in the virtual environment.',
      'Curiosity beyond the curriculum — students asked for math, the human body and space.',
      'Positive acceptance — enjoyable, different, and something they wanted to repeat.',
    ],
    voice: [
      'I could actually see it — it became easier to understand.',
      'It felt like real life. I forgot I was in the classroom.',
      'Initially needed help, then completed the tasks independently.',
    ],
    mediaLabel: 'FIELD-TRIAL VIDEO · GYAN DHARA IN CLASSROOMS',
  },
  governance: {
    eyebrow: 'RESEARCH GOVERNANCE',
    title:   'Responsible use of student data',
    desc:    'Student records are stored in the Gyan Dhara database. Research access is restricted, and external publication requires applicable consent.',
    principles: [
      { title: 'Data storage',        desc: 'Student records live in the Gyan Dhara database with role-based access.', color: 'purple', icon: 'Database' },
      { title: 'Restricted research', desc: 'Research access is limited to the evaluation team.',                       color: 'royal',  icon: 'Lock' },
      { title: 'Consent required',    desc: 'External publication requires the applicable school and parent consent.', color: 'mint',   icon: 'ShieldCheck' },
    ],
  },
  cta: {
    title: 'Ready to bring Gyan Dhara to your institution?',
    desc:  'Request a demo or begin a deployment discussion.',
    primary:  { label: 'Start Deployment', to: '/school/start-deployment' },
    secondary:{ label: 'Request Demo',     to: '/school/request-demo' },
  },
};

// =============================================================================
// 07 FAQs — Frame 47:112
// =============================================================================
export const SCHOOL_FAQ = {
  hero: {
    title: 'Frequently asked questions',
    desc:  'Clear answers about curriculum, access, hardware, classroom use, analytics and deployment.',
  },
  items: [
    { q: 'Which grades and subjects are supported?',
      a: 'Grades 8 and 9 Science and Mathematics, based on NCERT, alongside non-curriculum exploratory experiences.' },
    { q: 'Is the software free?',
      a: 'The complete software ecosystem has no licence fee through June 2027. Hardware and deployment components are institution-funded.' },
    { q: 'What is the minimum setup?',
      a: 'Three Meta Quest 3S headsets with recommended comfort straps, stools and remote-access configuration.' },
    { q: 'Is a dedicated VR lab required?',
      a: 'No. Gyan Dhara can operate as a portable classroom setup or in an existing activity space.' },
    { q: 'Does it work without internet?',
      a: 'Core VR modules work offline. Gyan Mitra and data synchronisation require internet.' },
    { q: 'How long is one module?',
      a: 'Typically 35–45 minutes, with one student using one headset.' },
    { q: 'Is teacher supervision required?',
      a: 'Continuous teaching is not required. Schools should schedule and manage device use.' },
    { q: 'Are student accounts compulsory?',
      a: 'No, but individual accounts are recommended for VR analytics and student-level progress.' },
    { q: 'Which languages are available?',
      a: 'English, Hindi and Assamese.' },
    { q: 'What happens after June 2027?',
      a: 'A paid institutional subscription may be introduced. Future terms will be communicated separately.' },
    { q: 'How quickly can deployment begin?',
      a: 'Approximately 7–10 days after agreement and receipt of hardware and logistics funds.' },
    { q: 'Can CSR or government funds be used?',
      a: 'Yes. Gyan Dhara does not restrict the source used by the institution to fund hardware and deployment.' },
  ],
  cta: {
    title:  'Ready to bring Gyan Dhara to your institution?',
    desc:   'Request a demo or begin a deployment discussion.',
    primary:  { label: 'Start Deployment', to: '/school/start-deployment' },
    secondary:{ label: 'Request Demo',     to: '/school/request-demo' },
  },
};

// =============================================================================
// 08 REQUEST DEMO — Frame 47:238
// =============================================================================
export const SCHOOL_REQUEST_DEMO = {
  hero: {
    title: 'Request an online demonstration',
    desc:  'See the VR modules, school portal, assessments and analytics before deciding on deployment.',
  },
  formTitle: 'School and contact details',
  schoolTypes: ['Government school', 'Private school', 'Public trust school', 'International school', 'Coaching institute', 'University / College', 'Other'],
  roles:       ['Principal', 'Vice Principal', 'Head of Department', 'Teacher', 'Administrator', 'Coordinator', 'Owner / Trustee', 'Other'],
  demoOptions: [
    { key: 'online',  label: 'Online product demo',  note: '' },
    { key: 'pilot',   label: 'Temporary pilot',      note: 'Requires an existing headset' },
    { key: 'both',    label: 'Both',                 note: '' },
  ],
  timeSlots: ['9:00 – 11:00', '11:00 – 13:00', '14:00 – 16:00', '16:00 – 18:00'],
  submit:      'Submit Demo Request',
  submitHint:  'We will contact you within 48 hours.',
  confirmation: {
    title: 'Confirmation state',
    body:  'Your demo request has been received. We will contact you within 48 hours to confirm the demonstration.',
  },
};

// =============================================================================
// 09 START DEPLOYMENT — Frame 48:2
// =============================================================================
export const SCHOOL_START_DEPLOYMENT = {
  hero: {
    title: 'Start a school deployment',
    desc:  'Submit the institution’s requirements. Every institution is eligible; the information is used to recommend and prepare the setup.',
  },
  steps: [
    { n: 1, label: 'Institution' },
    { n: 2, label: 'Student and setup' },
    { n: 3, label: 'Readiness' },
  ],
  stepTitles: {
    1: 'Step 1 · Institution details',
    2: 'Step 2 · Students and setup',
    3: 'Step 3 · Readiness confirmation',
  },
  schoolTypes: ['Government school', 'Private school', 'Public trust school', 'International school', 'Coaching institute', 'University / College', 'Other'],
  roles:       ['Principal', 'Vice Principal', 'Head of Department', 'Teacher', 'Administrator', 'Coordinator', 'Owner / Trustee', 'Other'],
  setupPresets: ['3 headsets', '5 headsets', '10 headsets', 'Custom'],
  intendedUse:  ['Curriculum modules', 'Exploratory experiences', 'Both'],
  accountOptions: [
    { value: 'yes', label: 'Yes',            note: 'Enables student-level VR analytics' },
    { value: 'no',  label: 'No',             note: 'Shared access without individual analytics' },
    { value: 'guidance', label: 'Need guidance', note: '' },
  ],
  readinessChecks: [
    'We understand that a minimum of three Quest 3S headsets is required.',
    'We understand that the institution funds hardware, accessories, setup and logistics.',
    'We understand that the Gyan Dhara software ecosystem has no licence fee through June 2027.',
    'We will follow the recommended deployment and usage protocols.',
    'We agree to be contacted regarding a customised deployment estimate.',
  ],
  submit: 'Submit Deployment Interest',
  confirmation: {
    title: 'Submission confirmation',
    body:  'Your institution is eligible to deploy Gyan Dhara. We are reviewing your requirements and will contact you within 48 hours to discuss the recommended setup, estimate and next steps.',
  },
};
